'use client';
import MobileAdProfiles from '@/constants/ad/mobile';
import { AdSlot } from '@/components/atoms/Ad/Adslot';
import DesktopAdProfiles from '@/constants/ad/desktop';

type RelatedNewsAdProps = {
  isDesktop: boolean;
};

const RelatedNewsAd = ({ isDesktop }: RelatedNewsAdProps) => {
  return (
    <div className='mb-4 min-h-[95px] border-b border-[#e2e8f1] pb-4 lg:pb-0'>
      {isDesktop ? (
        <AdSlot profile={DesktopAdProfiles.newsDetailInterested1} />
      ) : (
        <AdSlot profile={MobileAdProfiles.relatedNews} />
      )}
    </div>
  );
};

export default RelatedNewsAd;
